export default "__VITE_ASSET__Cec9M_VG__"